import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ConnectionInfo } from '../connection-wizard.component';

@Component({
  selector: 'app-connection-step-d',
  templateUrl: './connection-step-d.component.html',
  styleUrls: ['./connection-step-d.component.scss']
})
export class ConnectionStepDComponent implements OnInit {

  @Input() testResult: { success: boolean; message: string } | null = null;
  @Input() connectionInfo: ConnectionInfo | null = null;
  @Output() editConnection = new EventEmitter<void>();
  @Output() testConnection = new EventEmitter<void>();

  constructor() { }

  ngOnInit() {
  }

}
